import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faServer, faTruck } from "@fortawesome/free-solid-svg-icons";
import { faFortAwesome } from "@fortawesome/free-brands-svg-icons";

class ValueProposition extends React.Component {
    render() {
        return (
            <React.Fragment>
                <section className="bg-white" id="value">
                    <div className="container py-6">
                        <div className="row">
                            <div className="col-lg-4 mb-5 mb-lg-0">
                                <h1 className="value-prop-title">
                                    <span>Our Fleet</span>
                                </h1>
                                <h5 className="value-prop-subtitle">With our trucks ranging from regular, to heavy-duty, to specialised - we deliver it all</h5>
                                <p className="mb-0 value-prop-text">Our truck fleet consists of multiple regular trucks, heavy duty trucks, and refrigeratored trucks - meaning we’re the ultimate transportation provider in the country.</p>
                            </div>
                            <div className="col-lg-4 mb-5 mb-lg-0">
                            <h1 className="value-prop-title">
                                    <span>Our Expertise</span>
                                </h1>
                                <h5 className="value-prop-subtitle">We're seasoned professionals with tens of thousands of kms travelled here in Australia</h5>
                                <p className="mb-0 value-prop-text">With our tailored service and staff, you're in the right hands. We offer reliable, nationwide shipping suitable for all your business delivery needs.</p>
                            </div>
                            <div className="col-lg-4">
                            <h1 className="value-prop-title">
                                    <span>Our Promise</span>
                                </h1>
                                <h5 className="value-prop-subtitle">Rest assured with a 99% track record of delivering your goods ahead of time</h5>
                                <p className="mb-0 value-prop-text">Your time is money. We recognise how important the safe, secure and timely delivery of your goods is. We're committed to always going above and beyond for our clients.</p>
                            </div>
                        </div>
                    </div>
                    {/* <div className="svg-border-rounded-no-absolute svg-light">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0"></path></svg>
                    </div> */}
                </section>

            </React.Fragment>
        );
    }
}

export default ValueProposition;
